function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Draggable from 'vuedraggable';
import { containers, basicFields, advancedFields, customFields } from './widgetsConfig';
import { addWindowResizeHandler } from '@/utils/util';
import i18n from '@/utils/i18n';
import axios from 'axios';
// import SvgIcon from '@/components/svg-icon'
import { formCrudList } from '@/api/form';
import index from '@/components/uploadPicture/index.vue';
import { mapGetters } from 'vuex';
import { set } from 'nprogress';
import { init } from 'echarts/lib/echarts';
import { isArray } from 'xe-utils';
export default {
  name: 'FieldPanel',
  mixins: [i18n],
  components: {
    Draggable: Draggable
    // SvgIcon
  },
  props: {
    designer: Object
  },
  inject: ['getBannedWidgets', 'getDesignerConfig'],
  data: function data() {
    return {
      designerConfig: this.getDesignerConfig(),
      firstTab: 'componentLib',
      scrollerHeight: 0,
      activeNames: ['1', '2', '3', '4'],
      containers: containers,
      basicFields: basicFields,
      advancedFields: advancedFields,
      customFields: customFields,
      containersNames: containers.map(function (con) {
        return con.type;
      }),
      nameArr: []
    };
  },
  watch: {
    'designer.widgetList': {
      handler: function handler(val) {
        console.log('val', val);
        // this.crudList.forEach((item) => {
        //   item.field.forEach((fld) => {
        //     val.forEach((v) => {
        //       console.log('v', v)
        //       let names = this.crudStatusFilter(v, fld, [])
        //       if (names && names.length) this.nameArr = Array.from(new Set([...this.nameArr, ...names]))
        //       console.log('nameArr', this.nameArr)
        //       if (this.nameArr.includes(fld.options.name)) {
        //         fld.hide = true
        //       } else {
        //         fld.hide = false
        //       }
        //     })
        //   })
        // })
      },
      deep: true
    },
    crudList: {
      handler: function handler(val) {},
      deep: true,
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['crudList'])),
  created: function created() {
    var id = this.$route.query.id;
    this.getCrudList(id);
  },
  mounted: function mounted() {
    var _this = this;
    this.loadWidgets();
    this.scrollerHeight = window.innerHeight - 250 + 'px';
    addWindowResizeHandler(function () {
      _this.$nextTick(function () {
        _this.scrollerHeight = window.innerHeight - 250 + 'px';
      });
    });
  },
  methods: {
    getCrudList: function getCrudList(id) {
      var _this2 = this;
      formCrudList(id).then(function (res) {
        for (var i = 0; i < res.data.length; i++) {
          for (var j = 0; j < res.data[i].field.length; j++) {
            res.data[i].field[j].i = j;
            res.data[i].field[j].pidx = i;
          }
        }
        setTimeout(function () {
          _this2.$store.dispatch('app/setFormList', res.data);
        }, 300);
      });
    },
    isBanned: function isBanned(wName) {
      return this.getBannedWidgets().indexOf(wName) > -1;
    },
    loadWidgets: function loadWidgets() {
      this.containers = this.containers.map(function (con) {
        console.log('con', con);
        return _objectSpread(_objectSpread({}, con), {}, {
          displayName: con.name
        });
      }).filter(function (con) {
        return !con.internal;
      });
    },
    handleContainerWidgetClone: function handleContainerWidgetClone(origin) {
      return this.designer.copyNewContainerWidget(origin);
    },
    handleFieldWidgetClone: function handleFieldWidgetClone(origin) {
      console.log('handleFieldWidgetClone', origin);
      return this.designer.copyNewFieldWidget(origin);
    },
    checkContainerMove: function checkContainerMove(evt) {
      return this.designer.checkWidgetMove(evt);
    },
    checkFieldMove: function checkFieldMove(evt) {
      return this.designer.checkFieldMove(evt);
    },
    onContainerDragEnd: function onContainerDragEnd(evt) {
      //console.log('Drag end of container: ')
      //console.log(evt)
    },
    addContainerByDbClick: function addContainerByDbClick(container) {
      this.designer.addContainerByDbClick(container);
    },
    addFieldByDbClick: function addFieldByDbClick(widget) {
      this.designer.addFieldByDbClick(widget);
    },
    loadFormTemplate: function loadFormTemplate(jsonUrl) {
      var _this3 = this;
      this.$confirm(this.i18nt('designer.hint.loadFormTemplateHint'), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        axios.get(jsonUrl).then(function (res) {
          var modifiedFlag = false;
          if (typeof res.data === 'string') {
            modifiedFlag = _this3.designer.loadFormJson(JSON.parse(res.data));
          } else if (res.data.constructor === Object) {
            modifiedFlag = _this3.designer.loadFormJson(res.data);
          }
          if (modifiedFlag) {
            _this3.designer.emitHistoryChange();
          }
          _this3.$message.success(_this3.i18nt('designer.hint.loadFormTemplateSuccess'));
        }).catch(function (error) {
          _this3.$message.error(_this3.i18nt('designer.hint.loadFormTemplateFailed') + ':' + error);
        });
      }).catch(function (error) {
        console.error(error);
      });
    }
  }
};